import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef, HostListener,
  Input,
  OnDestroy,
  OnInit, OnChanges, SimpleChanges,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatDivider} from '@angular/material/divider';
import {PDF_ICON, TXT_ICON, WORD_ICON, XLSX_ICON} from '../../../shared/models/chatLinnegocios/icon_path';
import {allowedContentTypes, ChatFile} from '../../../shared/models/chatLinnegocios/ChatFile';
import {Negocio} from '../../../shared/models/negocio';
import {first, firstValueFrom, finalize, Subject, Subscription, takeUntil} from 'rxjs';
import {UserService} from '../../../core/services/user.service';
import {ChatService, enumStatusChat, mergeChatMessages} from '../../../core/services/chat.service';
import {MatDialog} from '@angular/material/dialog';
import {getUserId} from '../../../core/helpers/utilities';
import {GenericoService} from '../../../core/services/generico.service';
import {Timestamp} from 'firebase/firestore';
import {CommonModule, NgStyle} from '@angular/common';
import {DateFormatPipe, LinkifyPipe} from '../../../core/pippes/chat.pipe';
import {FilemessageComponent} from '../filemessage/filemessage.component';
import {MatMenu, MatMenuModule} from '@angular/material/menu';
import {FormsModule} from '@angular/forms';
import {MatBadge} from '@angular/material/badge';
import {ImageType} from '../chat-image-view-dialog/chat-image-view-dialog.component';
import {ImageViewerComponent} from '../image-viewer/image-viewer.component';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgStyle,
    DateFormatPipe,
    LinkifyPipe,
    FilemessageComponent,
    MatMenuModule,
    FormsModule,
    MatBadge,
  ],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  // ViewChilds
  @ViewChild('scrollframe') scrollframe!: ElementRef;
  @ViewChild('fileUpload') fileUpload!: ElementRef;
  // @ViewChild('messageInput') messageInput!: ElementRef;
  @ViewChildren('items') items!: QueryList<any>;

  @ViewChild('chatContent') chatContent!: ElementRef<HTMLDivElement>;
  @ViewChild('chatFooter') chatFooter!: ElementRef<HTMLDivElement>;
  @ViewChild('messageInput') messageInput!: ElementRef<HTMLTextAreaElement>;

  // Inputs
  @Input() chat: any;
  @Input() dataRight: any; //No se usa, solo se le pasa como parámetro ya que se utiliza donde se manda a traer para ir posicionado a lado del chat anterior.

  // Public vars
  public robado = false;
  public maxSizeFile = 15 * 1024 * 1024;
  public isEndMessage = false;
  public isChatLoading = false;
  public isActiveScroll = false;
  public isSendingMessage = false;
  public isUploading = false;
  public isLoading = true;
  public scroll = true;
  public minimize = false;
  public groupedMessages: any[] = [];
  public lastMessages: any[] = [];
  public messages: any[] = [];
  public pendingMessages: any[] = [];
  public viewingPending = false;
  public loadingPending = false;
  get displayedMessages(): any[] { return this.viewingPending ? this.pendingMessages : this.messages; }
  public user = 0;
  public idChat = 0;
  public negocio!: Negocio;
  public message = '';
  public file!: ChatFile | null;
  public filePath!: string;
  public url!: string;
  public ICONS_URL = '../../../assets/svg/chatFileIcons/';
  public chatInst: any;

  imagenView: any;

  // Subscriptions and subjects
  private detectorSub$!: Subscription;
  private destroyed$ = new Subject<void>();
  private reader: FileReader | null = null;
  private fileGeneration = 0;
  private requestId = '';
  private requestDraft = '';
  private readBusy = false;
  private readAcknowledged = new Set<string>();
  public errorMessage = '';
  get connection$() { return this.chatService.connection$; }
  private timers = new Set<ReturnType<typeof setTimeout>>();
  get canOperate(): boolean { return !!this.chatInst?.readMessages && this.chatInst?.agente?.id === getUserId() && this.chatInst.chatEstatus !== 'CERRADO'; }
  private later(action: () => void, delay: number): void {
    const timer = setTimeout(() => { this.timers.delete(timer); action(); }, delay); this.timers.add(timer);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chat'] && !changes['chat'].firstChange) {
      if (changes['chat'].previousValue?.idChat !== this.chat.idChat) {
        this.destroyed$.next(); this.timers.forEach(timer => clearTimeout(timer)); this.timers.clear(); this.message = ''; this.requestId = ''; this.requestDraft = ''; this.readBusy = false; this.errorMessage = ''; this.detectorSub$?.unsubscribe(); this.cancelFile(); this.messages = []; this.lastMessages = []; this.readAcknowledged.clear(); this.isEndMessage = false;
        this.pendingMessages = []; this.viewingPending = false; this.loadingPending = false;
        this.chatInst = this.chat; this.detectorSub$ = this.getChat();
      } else if (this.chatInst) this.chatInst = {...this.chatInst, readMessages: this.chat.readMessages};
    }
  }
  onMessageKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing && event.keyCode !== 229) { event.preventDefault(); this.send(); }
  }
  reconnect(): void { this.chatService.reconnect(); this.acknowledgeVisible(); }


  constructor(
    private userService: UserService,
    private chatService: ChatService,
    private genericoService: GenericoService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
  ) {
  }

  // Lifecycle
  /**
   * Hook que se ejecuta al inicializar el componente.
   * Asigna la instancia del chat recibido por input y se suscribe a cambios en el chat mediante `getChat()`.
   */
  ngOnInit(): void {
    this.chatInst = this.chat;
    this.detectorSub$ = this.getChat();
  }

  /**
   * Hook que se ejecuta después de que la vista ha sido inicializada.
   * Realiza el scroll al fondo del contenedor de mensajes para mostrar los más recientes.
   */
  ngAfterViewInit(): void {
    this.scrollToBottom();
    this.adjustChatContentHeight();
  }

  /**
   * Hook que se ejecuta cuando el componente se destruye.
   * Se encarga de limpiar la suscripción al detector de cambios del chat
   * y cancelar el archivo adjunto si existe alguno en proceso.
   */
  ngOnDestroy(): void {
    this.destroyed$.next(); this.destroyed$.complete(); this.detectorSub$?.unsubscribe(); this.cancelFile();
    this.timers.forEach(timer => clearTimeout(timer)); this.timers.clear();
  }

  // UI Actions
  /**
   * Alterna el estado minimizado del chat (expandir/contraer).
   * Si el chat está marcado como solo lectura (`readMessages`), se envía el evento para marcar los mensajes como leídos.
   * También realiza un pequeño scroll para asegurar que el contenido visible esté ajustado.
   */
  minimizeView(): void {
    this.minimize = !this.minimize;
    if (!this.minimize) { this.acknowledgeVisible(); this.scrollToBottom(); }
  }

  /**
   * Cierra la vista del chat actual llamando al servicio que gestiona los chats abiertos.
   */
  closeViewChat(): void {
    this.chatService.closeChatView('' + this.chatInst.idChat);
  }

  /**
   * Hace scroll hasta el final del contenedor de mensajes para mostrar el mensaje más reciente.
   */
  scrollToBottom(): void {
    this.later(() => { const element = this.scrollframe?.nativeElement; if (element && !this.minimize && !this.viewingPending && !this.loadingPending) element.scrollTop = element.scrollHeight; }, 100);
  }

  showPendingMessages(): void {
    if (this.loadingPending || this.minimize) return;
    this.loadingPending = true; this.errorMessage = '';
    this.chatService.getUnreadMessages(this.obtenerIdChat()).pipe(first(), takeUntil(this.destroyed$), finalize(() => this.loadingPending = false)).subscribe({
      next: messages => {
        // Keep this filtered view separate: historic cursors and recent messages must not change.
        const current = new Map(this.displayedMessages.map(message => [String(message.idChatMessage), message]));
        this.pendingMessages = messages.map(message => current.get(String(message.idChatMessage)) || message)
          .filter(message => !this.readAcknowledged.has(String(message.idChatMessage)) && message.messageEstatus === 'NUEVO');
        this.viewingPending = true; this.groupMessagesByDate();
        this.registerDisplayedMessageIds();
        this.later(() => { if (!this.viewingPending) return; if (this.scrollframe?.nativeElement) this.scrollframe.nativeElement.scrollTop = 0; this.acknowledgeVisible(); this.adjustChatContentHeight(); }, 150);
      },
      error: () => this.errorMessage = 'No se pudieron cargar los pendientes. Vuelve a intentar.'
    });
  }
  showRecentMessages(): void {
    this.viewingPending = false; this.groupMessagesByDate(); this.registerDisplayedMessageIds(); this.scrollToBottom();
    this.later(() => { this.acknowledgeVisible(); this.adjustChatContentHeight(); }, 150);
  }
  private registerDisplayedMessageIds(): void {
    // Reserve room for the historic pending page as well as the recent conversation.
    this.chatService.registerMessageIds(this.obtenerIdChat(), mergeChatMessages(this.messages.slice(-450), this.pendingMessages).slice(-500));
  }

  /**
   * Evento que se dispara al hacer scroll manual en el contenedor.
   * Marca que el usuario ha activado el scroll y si está en el tope superior, carga mensajes anteriores.
   */
  onScroll(): void {
    this.cargarMensajesAnteriores(); this.acknowledgeVisible();
  }

  // Chat logic
  /**
   * Se suscribe a los cambios del documento del chat en Firestore.
   * Si el chat aún no ha sido tomado y está en modo "solo ver", se intenta tomar el chat.
   * Detecta si el chat ha sido robado por otro agente y actualiza la instancia.
   * Si el chat no está minimizado y está en modo solo lectura, marca los mensajes como leídos.
   */
  getChat(): Subscription {
    return this.chatService.watchConversation(this.obtenerIdChat()).pipe(takeUntil(this.destroyed$)).subscribe(data => {
      const element = this.scrollframe?.nativeElement;
      const atBottom = !element || element.scrollHeight - element.scrollTop - element.clientHeight < 80;
      if (data.chat) this.chatInst = {...data.chat, readMessages: this.chatInst.readMessages};
      this.robado = this.chatInst?.agente?.id !== getUserId();
      const pendingIds = new Set(this.pendingMessages.map(message => String(message.idChatMessage)));
      const recentIds = new Set(this.messages.map(message => String(message.idChatMessage)));
      this.messages = mergeChatMessages(this.messages, (data.messages || []).filter((message: any) => !pendingIds.has(String(message.idChatMessage)) || recentIds.has(String(message.idChatMessage))));
      const updates = new Map<string, any>((data.messages || []).map((message: any) => [String(message.idChatMessage), message]));
      this.pendingMessages = this.pendingMessages.map(message => updates.get(String(message.idChatMessage)) || message);
      this.groupMessagesByDate(); this.isLoading = false;
      this.registerDisplayedMessageIds();
      this.later(() => { this.acknowledgeVisible(); }, 150);
      if (atBottom) this.scrollToBottom();
    });
  }
  private acknowledgeVisible(): void {
    if (!this.canOperate || this.loadingPending || this.minimize || document.visibilityState !== 'visible' || this.readBusy) return;
    const ids = this.displayedMessages.filter(message => message.messageUser && message.messageEstatus === 'NUEVO' && this.isMessageVisible(message.idChatMessage) && !this.readAcknowledged.has(String(message.idChatMessage))).map(message => message.idChatMessage).slice(-200);
    if (!ids.length) return;
    this.readBusy = true;
    this.chatService.readMessages({idChat: this.chatInst.idChat, task: 'READ', observedMessageIds: ids}).pipe(first(), takeUntil(this.destroyed$), finalize(() => this.readBusy = false)).subscribe({
      next: () => { ids.forEach(id => this.readAcknowledged.add(String(id))); },
      error: () => this.errorMessage = 'No se pudo confirmar la lectura. Puedes volver a conectar.'
    });
  }
  trackGroup(_index: number, group: any): string { return group.date; }
  trackMessage(_index: number, message: any): string { return String(message.idChatMessage); }
  private isMessageVisible(id: any): boolean {
    const frame = this.scrollframe?.nativeElement; if (!frame) return false;
    const element = frame.querySelector('[data-message-id="' + String(id) + '"]'); if (!element) return false;
    const bounds = element.getBoundingClientRect(); const viewport = frame.getBoundingClientRect();
    return bounds.top < viewport.bottom && bounds.bottom > viewport.top;
  }
  @HostListener('document:visibilitychange') onVisibility(): void { this.acknowledgeVisible(); }

  /**
   * Carga los mensajes del día actual desde Firestore y actualiza la interfaz.
   * Agrupa los mensajes por fecha y determina si hay scroll activo.
   */
  private cargarMensajesYActualizarVista(): void { this.chatService.reconnect(); }

  /**
   * Carga mensajes anteriores al día actual desde Firestore si el scroll está al inicio.
   * Agrega los mensajes al principio del arreglo y agrupa nuevamente por fecha.
   */
  private cargarMensajesAnteriores(): void {
    if (this.viewingPending || this.loadingPending || this.isEndMessage || this.isChatLoading || !this.scrollAlInicio() || !this.messages.length) return;
    this.isChatLoading = true;
    const element = this.scrollframe?.nativeElement; const height = element?.scrollHeight || 0;
    this.chatService.getMessagesPastDays(this.obtenerIdChat(), this.messages[0]).pipe(first(), takeUntil(this.destroyed$), finalize(() => this.isChatLoading = false)).subscribe({
      next: messages => {
        this.isEndMessage = messages.length < 20;
        this.messages = mergeChatMessages(messages, this.messages); this.lastMessages = this.messages; this.groupMessagesByDate(); this.registerDisplayedMessageIds();
        this.later(() => { if (element && !this.viewingPending && !this.loadingPending) element.scrollTop += element.scrollHeight - height; }, 0);
      }, error: () => this.errorMessage = 'No se pudo cargar el historial. Vuelve a intentar.'
    });
  }

  /**
   * Verifica si el scroll está en la parte superior del contenedor de mensajes.
   * Se utiliza para saber si se deben cargar más mensajes.
   */
  private scrollAlInicio(): boolean {
    return this.scrollframe && this.scrollframe.nativeElement.scrollTop === 0;
  }

  /**
   * Agrupa los mensajes del chat por fecha (día).
   * Se utiliza para estructurar la visualización en la interfaz.
   */
  groupMessagesByDate(): void {
    const groups: { [key: string]: any[] } = {};

    // Agrupar mensajes por fecha
    this.displayedMessages.forEach((message) => {
      const messageDate = new Date(
        message.dateCreated.seconds * 1000 + message.dateCreated.nanoseconds / 1000000,
      );
      const year = messageDate.getFullYear();
      const month = String(messageDate.getMonth() + 1).padStart(2, '0');
      const day = String(messageDate.getDate()).padStart(2, '0');
      const dateKey = `${year}-${month}-${day}`;

      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(message);
    });

    // Ordenar las fechas en orden descendente (más recientes primero)
    const sortedDates = Object.keys(groups).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime(),
    );

    // Ordenar los mensajes dentro de cada grupo por fecha en orden descendente
    sortedDates.forEach((dateKey) => {
      groups[dateKey].sort(
        (a, b) => a.dateCreated.seconds - b.dateCreated.seconds || a.dateCreated.nanoseconds - b.dateCreated.nanoseconds || Number(a.idChatMessage) - Number(b.idChatMessage),
      );
    });

    // Crear la estructura final
    this.groupedMessages = sortedDates.map((dateKey) => ({
      date: dateKey,
      messages: groups[dateKey],
    }));
  }

  // Messaging actions

  /**
   * Envía un mensaje en el chat. Si hay un archivo adjunto, también se incluye.
   * Valida si el usuario tiene permiso para enviar (no robado) y si el mensaje es válido.
   * Luego, limpia los campos y enfoca nuevamente el input de texto.
   */
  send(): void {
    if (!this.canOperate || this.isSendingMessage || this.isUploading || !this.validateMensaje()) return;
    const draft = JSON.stringify([this.message, this.file?.fileName, this.file?.encode]);
    if (draft !== this.requestDraft || !this.requestId) { this.requestDraft = draft; this.requestId = crypto.randomUUID(); }
    const payload = {task: enumStatusChat.SEND, message: this.message, file: this.file ? {...this.file} : null, idChat: this.chatInst.idChat, clientRequestId: this.requestId};
    this.isSendingMessage = true; this.errorMessage = '';
    this.chatService.sendMessage(payload).pipe(first(), takeUntil(this.destroyed$), finalize(() => this.isSendingMessage = false)).subscribe({
      next: () => { this.resetInputs(); this.requestId = ''; this.scrollToBottom(); this.chatService.reconnect(); },
      error: () => this.errorMessage = 'No se confirmó el envío. Conservamos tu mensaje; vuelve a pulsar enviar para reintentar.'
    });
  }

  /**
   * Procesa la carga de un archivo seleccionado por el usuario.
   * Valida el tamaño máximo y el tipo de archivo permitido.
   * Codifica el archivo en base64 y lo asigna a `this.file`.
   */
  saveFile(event: any): void {
    const input: File | undefined = event.target.files?.[0];
    if (!input || this.isSendingMessage || !this.canOperate) return;
    this.cancelFile();
    if (input.size > this.maxSizeFile) { this.showErrorSizeFileMessage(); return; }
    if (!this.validateFile(input.type)) return;
    const generation = ++this.fileGeneration;
    const selected = {fileName: input.name, encode: '', url: '', contentType: input.type, fileSize: input.size} as ChatFile;
    this.file = selected; this.isUploading = true;
    const reader = this.reader = new FileReader();
    reader.onload = () => { if (this.fileGeneration === generation && this.file === selected) { selected.encode = String(reader.result); this.isUploading = false; } };
    reader.onerror = () => { if (this.fileGeneration === generation) { this.cancelFile(); this.errorMessage = 'No se pudo leer el archivo. Selecciónalo de nuevo.'; } };
    reader.onabort = () => { if (this.fileGeneration === generation) this.isUploading = false; };
    reader.readAsDataURL(input);
  }

  /**
   * Cancela la carga del archivo y limpia las variables relacionadas.
   */
  cancelFile(): void {
    this.fileGeneration++; if (this.reader?.readyState === FileReader.LOADING) this.reader.abort(); this.reader = null;
    this.isUploading = false; this.filePath = ''; if (this.fileUpload?.nativeElement) this.fileUpload.nativeElement.value = ''; this.file = null;
  }

  /**
   * Elimina un mensaje específico del chat.
   * Abre un diálogo de confirmación y, si se confirma, hace la petición al backend.
   */
  async deleteMessages(message: string) {
    if (this.canOperate) {
      const payload = {
        messageId: message,
        anonimo: this.chatInst.typeChat === 'Anonymous',
      };

      const isConfirmed = await this.genericoService.confirmDialog(
        '¿Estás seguro de eliminar los mensajes?'
      );
      if (!isConfirmed) {
        return;
      }

      this.chatService
        .deleteMessages(payload)
        .pipe(first())
        .subscribe({next: () => this.chatService.reconnect(), error: () => this.errorMessage = 'No se pudo eliminar el mensaje.'});
    }
  }

  /**
   * Valida si el mensaje es válido para enviar.
   * Un mensaje es válido si tiene texto no vacío o hay un archivo adjunto.
   * Cambia el borde del input como retroalimentación visual.
   */
  validateMensaje(): boolean {
    const valido = this.message.trim() !== '' || this.file != null;

    const input = this.messageInput?.nativeElement;
    if (input) {
      input.style.border = valido ? '1px solid black' : '1px solid red';
    }

    return valido;
  }

  /**
   * Valida si el tipo MIME del archivo está permitido.
   * Si el tipo no es válido, muestra un mensaje de error.
   *
   * @param type - Tipo MIME del archivo a validar
   * @returns `true` si el tipo es permitido, `false` en caso contrario
   */
  validateFile(type: string): boolean {
    const allowed: string[] = Object.values(allowedContentTypes);

    if (!allowed.includes(type)) {
      this.showErrorFileTypeMessage();
    }

    return allowed.includes(type);
  }

  /**
   * Muestra un diálogo de error cuando el archivo excede el tamaño máximo permitido (15MB).
   * Además, cancela la carga del archivo actual.
   */
  showErrorSizeFileMessage(): void {

    this.genericoService.confirmDialog('El límite de subida de archivos es de 15 mb')

    this.cancelFile();
  }

  /**
   * Muestra un diálogo de error cuando el archivo seleccionado tiene un formato no permitido.
   * Construye dinámicamente la lista de extensiones válidas ignorando algunas extensiones técnicas.
   */
  showErrorFileTypeMessage(): void {
    let allowed = '';

    // Tipos que no se mostrarán como extensión al usuario
    const ignore = [
      'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'vnd.openxmlformats-officedocument.wordprocessingml.document',
      'msword',
      'vnd.ms-excel',
      'plain',
    ];

    Object.values(allowedContentTypes).forEach((value: string) => {
      const ext = value.split('/')[1];
      if (!ignore.includes(ext)) {
        allowed += ext + ',';
      }
    });

    // Agregar manualmente extensiones comunes legibles para el usuario
    allowed += 'doc,docx,xlsx,txt';
    this.genericoService.confirmDialog('Error, solo archivos con formato: ' + allowed)

  }

  /**
   * Determina qué ícono o contenido mostrar para el archivo seleccionado.
   * - Si es imagen, se muestra directamente la imagen codificada en base64.
   * - Si es otro tipo de archivo, se selecciona el ícono correspondiente.
   *
   * @returns URL del ícono o contenido a mostrar
   */
  whichFile(): string {
    if (!this.file) {
      return this.ICONS_URL + TXT_ICON;
    }

    if (this.isImage()) {
      return this.file.encode;
    }

    this.imagenView = this.ICONS_URL + this.obtenerIconoArchivo(this.file.contentType);
    return this.ICONS_URL + this.obtenerIconoArchivo(this.file.contentType);
  }

  /**
   * Verifica si el archivo actual es una imagen.
   *
   * @returns `true` si el archivo es de tipo imagen, `false` en caso contrario
   */
  isImage(): boolean {
    return this.file?.contentType.startsWith('image/') || false;
  }

  /**
   * Inicia sesión remota en el punto de venta del usuario (solo modo agente).
   * Utiliza un diálogo de confirmación y abre la URL devuelta por el backend en una nueva ventana.
   */
  async inicioSesionRemoto() {
    const userId = this.chatInst.usuuarioPDV.id;

    const isConfirmed = await this.genericoService.confirmDialog(
      `Estás a punto de cerrar el chat. <br> Por favor, confirma si deseas finalizar la conversación.`
    );
    if (!isConfirmed) {
      return;
    }

    this.userService.inicioSesionRemoto({userId}).subscribe((response) => {
      window.open(response.url, 'Punto de venta remoto');
    });
  }

  /**
   * Cierra el chat actual si el usuario tiene permiso.
   * Muestra un diálogo de confirmación y luego cambia el estado del chat a cerrado.
   *
   * Si el usuario no tiene permiso o no hay agente asignado, muestra un mensaje de error.
   */
  async closeChat() {
    if (this.canOperate) {
      if (!this.tienePermiso()) {
        this.mostrarDialogoSinPermiso('Error', 'No tienes asignado este chat');
        return;
      }

      const isConfirmed = await this.genericoService.confirmDialog(
        `Estás a punto de cerrar el chat. <br> Por favor, confirma si deseas finalizar la conversación.`
      );
      if (!isConfirmed) {
        return;
      }

      const payload = {
        id: this.chatInst.usuario.id,
        anonimo: this.chatInst.typeChat === 'Anonymous',
        idChat: this.chatInst.idChat,
        alertaClose: true,
      };

      this.chatService.closeChat(payload).pipe(first(), takeUntil(this.destroyed$)).subscribe({next: () => this.closeViewChat(), error: () => this.errorMessage = 'No se pudo cerrar el chat. La conversación sigue abierta.'});

    } else {
      this.genericoService.errorDialog('No tienes asignado este chat o el chat no tiene mensajes')
    }
  }

  /**
   * Marca los mensajes del chat como leídos.
   * Este método es asincrónico y espera que se complete la petición.
   *
   * @param payload - Objeto con los datos necesarios para actualizar el estado de lectura
   */
  async readMessages(payload: any) { return firstValueFrom(this.chatService.readMessages(payload)); }

  // Helpers

  /**
   * Convierte un timestamp de Firebase a una cadena con formato "hh:mm".
   *
   * @param t - Timestamp de Firebase (con segundos y nanosegundos)
   * @returns Hora en formato "hh:mm"
   */
  getTime(t: Timestamp): string {
    const date: Date = new Date(t.seconds * 1000 + t.nanoseconds / 1000000);
    const hours: string = String(date.getHours()).padStart(2, '0');
    const minutes: string = String(date.getMinutes()).padStart(2, '0');
    return hours + ':' + minutes;
  }

  /**
   * Limpia los campos del formulario de envío de mensaje,
   * eliminando el archivo, mensaje y estado de carga.
   */
  private resetInputs(): void {
    this.message = '';
    this.file = null;
    this.filePath = '';
    if (this.fileUpload?.nativeElement) this.fileUpload.nativeElement.value = '';
    this.isUploading = false;
  }

  /**
   * Obtiene el identificador del chat usado en Firebase.
   * Si es anónimo, antepone una "A" al ID de chat.
   *
   * @returns ID del chat para usar en Firestore
   */
  private obtenerIdChat(): string {
    return this.chatInst.typeChat !== 'Anonymous'
      ? this.chatInst.usuario.id.toString()
      : 'A' + this.chatInst.idChat.toString();
  }

  /**
   * Verifica si el agente actual tiene permiso para operar sobre el chat.
   *
   * @returns `true` si el chat está asignado al agente, `false` en otro caso
   */
  private tienePermiso(): boolean {
    return this.canOperate;
  }

  /**
   * Muestra un diálogo informativo cuando el usuario no tiene permiso para ejecutar una acción.
   *
   * @param titulo - Título del diálogo (opcional)
   * @param mensaje - Mensaje a mostrar (opcional)
   */
  private mostrarDialogoSinPermiso(
    titulo = 'No puedes realizar esta acción',
    mensaje = 'No tienes este chat asignado',
  ): void {

    const isConfirmed = this.genericoService.confirmDialog(
      mensaje
    );
    if (!isConfirmed) {
      return;
    }
  }

  /**
   * Determina si el chat fue tomado por otro agente (es decir, si fue robado).
   * Si lo fue, muestra un diálogo informativo y retorna `true`.
   *
   * @returns `true` si el chat está robado, `false` si no
   */
  private esRobado(): boolean {
    if (this.robado) {
      this.mostrarDialogoSinPermiso();
      return true;
    }
    return false;
  }

  /**
   * Determina qué ícono debe mostrarse según el tipo MIME del archivo.
   *
   * @param contentType - Tipo MIME del archivo
   * @returns Ruta del ícono que representa el tipo de archivo
   */
  private obtenerIconoArchivo(contentType: string): string {
    const tipo = contentType.split('/')[1];

    switch (tipo) {
      case 'pdf':
        return PDF_ICON;
      case 'txt':
      case 'plain':
        return TXT_ICON;
      case 'msword':
      case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
        return WORD_ICON;
      case 'xlsx':
      case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return XLSX_ICON;
      case 'mp4':
        return TXT_ICON; // Podrías cambiar esto si agregas un ícono de video
      default:
        return TXT_ICON;
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.adjustChatContentHeight();
  }

  adjustTextareaHeight(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // Resetea la altura para recalcular
    const scrollHeight = textarea.scrollHeight; // Altura necesaria para el contenido
    const maxHeight = parseInt(window.getComputedStyle(textarea).maxHeight, 10); // Obtén la altura máxima definida en CSS

    // Ajusta la altura pero no excede el máximo
    textarea.style.height = scrollHeight > maxHeight ? `${maxHeight}px` : `${scrollHeight}px`;

    this.adjustChatContentHeight();
  }

  private adjustChatContentHeight() {
    const header = document.querySelector('.chat-header') as HTMLElement;
    const headerHeight = header ? header.offsetHeight : 65; // fallback

    if (!this.chatFooter?.nativeElement || !this.scrollframe?.nativeElement) return;
    const footerHeight = this.chatFooter.nativeElement.offsetHeight;
    const windowHeight = window.innerHeight;

    const newHeight = windowHeight - headerHeight - footerHeight - 50;
    this.scrollframe.nativeElement.style.height = `${newHeight}px`;
  }

  openImages(imagen: string): void {

    const image: ImageType = {
      nombre: this.file?.fileName || '',
      url: imagen,
    };
    this.dialog.open(ImageViewerComponent, {
      panelClass: 'foto-dialog',
      data: image,
    });
  }
}

/**
 * Convierte un archivo (File) a base64 utilizando FileReader.
 * Se utiliza para previsualizar archivos o enviarlos codificados por la red.
 *
 * @param file - Archivo que se desea convertir a base64
 * @param callback - Función que recibe como argumento la cadena base64 resultante
 */
function encodeFile(file: File, callback: (base64File: string) => void): void {
  const reader = new FileReader();

  reader.onload = () => {
    try {
      const base64File = reader.result as string;
      callback(base64File);
    } catch (err) {
      console.log(err); // Manejo simple del error, puede mejorarse según el contexto
    }
  };

  reader.readAsDataURL(file); // Inicia la lectura del archivo como URL base64
}
